import { Box } from '@nimbus-ds/components';
import { Repeater } from 'commons/components';
import { TransferListRowSkeleton } from './TransferListRow';

const rowSkeleton = () => <TransferListRowSkeleton />;

export function TransferMobileSkeleton() {
  return (
    <Box display="flex" flexDirection="column">
      <Repeater times={5} item={rowSkeleton} />
    </Box>
  );
}
